<div class="grid-stack-item-content" [ngClass]="{ isDraggable: draggable }">
  <div
    class="widget-heading"
    (mousedown)="onMouseDown()"
    (mouseup)="onMouseUp()"
  >
    <div class="title">{{ title }}</div>
    <div class="options">
      <button mat-icon-button>
        <svg-icon
          src="assets/svg/trashcan.svg"
          (click)="delete()"
          [svgStyle]="{
            'width.px': '17',
            'height.px': '17'
          }"
          svgClass="grey"
          viewBox="auto"
        ></svg-icon>
      </button>
    </div>
  </div>
  <div class="widget-content" lhpeElementLoader #elementLoader="elementloader">
    <div class="row">
      <div class="icon">
        <svg-icon src="assets/svg/exec-summary/mobile-location.svg"></svg-icon>
      </div>
      <div class="graph">
        <div
          echarts
          [options]="mobileLocationChartOption"
          class="pie-chart"
        ></div>
      </div>
    </div>
  </div>
</div>
